<app-header [headerText]="employeeInfo"></app-header>
<button mat-fab color="primary" aria-label="return" [routerLink]="['./../home']">
  <mat-icon>keyboard_arrow_left</mat-icon>
</button>

<mat-tab-group class="parent" mat-align-tabs="center" animationDuration="0ms" dynamicHeight=true
  (selectedTabChange)="tabChanged($event)" [selectedIndex]="contentLocation.tabIndex"
  *ngIf="logicService.dataManager.principalDataLoader.employee">

  <mat-tab>

    <ng-template mat-tab-label>
      <img class="img-responsive center-block" src="{{caja}}" />
    </ng-template>

    <mat-tab-group class="child" animationDuration="0ms" dynamicHeight="true"
      [selectedIndex]="contentLocation.detailIndex" (selectedTabChange)="subTabChangeSavings($event)">

      <mat-tab></mat-tab>

      <mat-tab [disabled]="shouldDisablePermanentSavingButton">

        <ng-template mat-tab-label>
          <div><img class="img-responsive center-block" src="{{cajaIcon}}" [matTooltip]="permanentSavingDisabledReason"
              aria-label="mensaje" matTooltipPosition="above" [matTooltipDisabled]="!shouldDisablePermanentSavingButton"
              [matBadgeHidden]="!shouldDisablePermanentSavingButton" matBadge="?" matBadgePosition="after"
              matBadgeColor="accent" matBadgeSize="large" /></div>
          Caja De Ahorro<br>Permanente<br>&nbsp;
        </ng-template>

        <app-ps-registration [contentLocation]="contentLocation"
          *ngIf="(contentLocation.tabIndex === 0 && contentLocation.detailIndex === 1) && !activeStatusPermanentSavings">
        </app-ps-registration>
        <app-ps-details [contentLocation]="contentLocation"
          *ngIf="(contentLocation.tabIndex === 0 && contentLocation.detailIndex === 1) && activeStatusPermanentSavings">
        </app-ps-details>


      </mat-tab>

      <mat-tab *ngIf="!shouldHideRetirementSavings">

        <ng-template mat-tab-label>
          <div><img class="img-responsive center-block" src="{{cajaIcon}}" /></div>
          Caja De Ahorro<br>Retiro<br>&nbsp;
        </ng-template>

        <app-rs-statement *ngIf="(contentLocation.tabIndex === 0 && contentLocation.detailIndex === 2)">
        </app-rs-statement>


      </mat-tab>
      <mat-tab [disabled]="shareSavingsDisabled" *ngIf="shareSavingsHide && shareSavingsParameters">

        <ng-template mat-tab-label>
          <div><img class="img-responsive center-block"
              matTooltip="En este momento se encuentra fuera del periodo de adquisición." aria-label="mensaje"
              matTooltipPosition="above" [matTooltipDisabled]="!shareSavingsDisabled" src="{{cajaIcon}}" /></div>
          Inversión<br>Por Acciones<br>&nbsp;
        </ng-template>

        <div>
          <app-ss-user [shareSavingsParameters]="shareSavingsParameters" [contentLocation]="contentLocation"
          *ngIf="(contentLocation.tabIndex === 0 && contentLocation.detailIndex !== 1)">
          </app-ss-user>
        </div>
      </mat-tab>

    </mat-tab-group>

  </mat-tab>

  <mat-tab>

    <ng-template mat-tab-label>
      <img class="img-responsive center-block" src="{{prestamos}}" />
    </ng-template>

    <mat-tab-group class="child" animationDuration="0ms" dynamicHeight="true"
      [selectedIndex]="contentLocation.detailIndex" (selectedTabChange)="subTabChangeLoans($event)">

      <mat-tab></mat-tab>

      <mat-tab [disabled]="shouldDisablePermanentLoanButton">

        <ng-template mat-tab-label>
          <div><img [matTooltip]="permanentSavingLoanDisabledReason" aria-label="mensaje" matTooltipPosition="above"
              [matTooltipDisabled]="!shouldDisablePermanentLoanButton"
              [matBadgeHidden]="!shouldDisablePermanentLoanButton" matBadge="?" matBadgePosition="after"
              matBadgeColor="accent" matBadgeSize="large" class="img-responsive center-block" src="{{prestamosIcon}}" />
          </div>
          Caja De Ahorro<br>Permanente<br>&nbsp;
        </ng-template>

        <app-pl-request [contentLocation]="contentLocation"
          *ngIf="!logicService.dataManager.principalDataLoader.employee.permanentSavingsLoan && (contentLocation.tabIndex === 1 && contentLocation.detailIndex === 1)">
        </app-pl-request>
        <app-pl-details [contentLocation]="contentLocation"
          *ngIf="logicService.dataManager.principalDataLoader.employee.permanentSavingsLoan && (contentLocation.tabIndex === 1 && contentLocation.detailIndex === 1)">
        </app-pl-details>


      </mat-tab>

      <mat-tab *ngIf="!shouldHideRetirementLoan">

        <ng-template mat-tab-label>
          <div><img class="img-responsive center-block" src="{{prestamosIcon}}"
              [matTooltip]="retirementSavingLoanDisabledReason" aria-label="mensaje" matTooltipPosition="above"
              [matTooltipDisabled]="!shouldDisableRetirementLoanButton"
              [matBadgeHidden]="!shouldDisableRetirementLoanButton" matBadge="?" matBadgePosition="after"
              matBadgeColor="accent" matBadgeSize="large" /></div>
          Caja De Ahorro<br>Retiro<br>&nbsp;
        </ng-template>


        <app-rl-request [contentLocation]="contentLocation"
          *ngIf="!logicService.dataManager.principalDataLoader.employee.retirementSavingsLoan && (contentLocation.tabIndex === 1 && contentLocation.detailIndex === 2)">
        </app-rl-request>
        <app-rl-details [contentLocation]="contentLocation"
          *ngIf="logicService.dataManager.principalDataLoader.employee.retirementSavingsLoan && (contentLocation.tabIndex === 1 && contentLocation.detailIndex === 2)">
        </app-rl-details>


      </mat-tab>

    </mat-tab-group>

  </mat-tab>

  <mat-tab>

    <ng-template mat-tab-label>
      <img class="img-responsive center-block" src="{{fondo}}" />
    </ng-template>

    <mat-tab-group class="child" animationDuration="0ms" dynamicHeight="true"
      [selectedIndex]="contentLocation.detailIndex" (selectedTabChange)="subTabChangeFunds($event)">

      <mat-tab></mat-tab>

      <mat-tab [disabled]="shouldDisableLongFund">

        <ng-template mat-tab-label>
          <div><img class="img-responsive center-block" src="{{fondoIcon}}"
              matTooltip="No existen datos en los acumulados del colaborador para este ciclo" aria-label="mensaje"
              matTooltipPosition="above" [matTooltipDisabled]="!shouldDisableLongFund"
              [matBadgeHidden]="!shouldDisableLongFund" matBadge="?" matBadgePosition="after" matBadgeColor="accent"
              matBadgeSize="large" /></div>
          Fondo De Ahorro<br>Largo<br>&nbsp;
        </ng-template>

        <app-lsf-statement type="FAL" *ngIf="contentLocation.tabIndex === 2 && contentLocation.detailIndex === 1">
        </app-lsf-statement>


      </mat-tab>

      <mat-tab *ngIf="!hideShortFund">

        <ng-template mat-tab-label>
          <div><img class="img-responsive center-block" src="{{fondoIcon}}"
              matTooltip="No existen datos en los acumulados del colaborador para este ciclo" aria-label="mensaje"
              matTooltipPosition="above" [matTooltipDisabled]="!shouldDisableShortFund"
              [matBadgeHidden]="!shouldDisableShortFund" matBadge="?" matBadgePosition="after" matBadgeColor="accent"
              matBadgeSize="large" /></div>
          Fondo De Ahorro<br>Corto<br>&nbsp;
        </ng-template>

        <app-lsf-statement type="FAC" *ngIf="contentLocation.tabIndex === 2 && contentLocation.detailIndex === 2">
        </app-lsf-statement>

      </mat-tab>

    </mat-tab-group>

  </mat-tab>

</mat-tab-group>